import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileQuestion, Settings, Users, LogOut } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/admin/questions', icon: FileQuestion, label: 'Fragen' },
  { path: '/admin/config', icon: Settings, label: 'Konfiguration' },
  { path: '/admin/leads', icon: Users, label: 'Bewerbungen' },
];

export default function AdminLayout({ children }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex" data-testid="admin-layout">
      <aside className="w-56 bg-[#121214] border-r border-white/5 flex flex-col shrink-0">
        <div className="p-5 border-b border-white/5">
          <h2 className="font-outfit font-bold text-lg text-white">IT-Quiz</h2>
          <p className="text-xs text-[#4B5563]">Admin Panel</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.path} to={item.path} end={item.path === '/admin'}
              data-testid={`admin-nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all
                ${isActive ? 'bg-[#3B82F6]/15 text-[#60A5FA]' : 'text-[#9CA3AF] hover:bg-white/5 hover:text-white'}`
              }
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5">
          <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-[#9CA3AF] hover:bg-white/5 hover:text-white w-full transition-all" data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4" /> Abmelden
          </button>
        </div>
      </aside>
      <main className="flex-1 p-6 overflow-auto">
        {children}
      </main>
    </div>
  );
}
